import { render, staticRenderFns } from "./CardEvent.vue?vue&type=template&id=028382d9&scoped=true"
import script from "./CardEvent.vue?vue&type=script&lang=js"
export * from "./CardEvent.vue?vue&type=script&lang=js"
import style0 from "./CardEvent.vue?vue&type=style&index=0&id=028382d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028382d9",
  null
  
)

export default component.exports